import styled from 'styled-components'

export const Container = styled.div({
  margin: '0 auto',
  maxWidth: '76.8rem',
})
